import { Button } from "@wags/ui/button.tsx";
import type { ReactNode } from "react";
import type { ProviderType } from "@wags/catalog/pure.ts";
import type { PrimaryAction } from "./dog-listing-actions";
import { ListingProviderName } from "./listing-provider-name";

export function getBuyBoxVariant(value: string | undefined): BuyBoxVariant {
    if (value === "provider" || value === "bare") return value;
    return "provider";
}

export function DesktopBackButton({
    onClick,
    className,
}: {
    onClick: () => void;
    className?: string;
}) {
    return (
        <Button
            type="button"
            variant="outline-ink"
            emphasis="cta"
            size="touch"
            onClick={onClick}
            className={className}
        >
            Back
        </Button>
    );
}

export type BuyBoxVariant = "provider" | "bare";

export function DesktopBuyBox({
    variant,
    name,
    priceDisplay,
    providerName,
    providerId,
    providerIsVerified,
    providerType,
    contact,
    actions,
    contactHelp,
}: {
    variant: BuyBoxVariant;
    name: string;
    priceDisplay: string;
    providerName?: string;

    providerId?: string;
    providerIsVerified?: boolean;
    providerType: ProviderType;
    contact?: PrimaryAction;
    actions: ReactNode;
    contactHelp: (cta: ReactNode) => ReactNode;
}) {
    return (
        <div className="relative z-10">
            <p className="mb-2 text-price text-doberman-black/65">
                {priceDisplay}
            </p>
            <div className="flex items-center justify-between gap-4">
                <h1 className="min-w-0 text-page-title text-doberman-black text-balance break-words">
                    {name}
                </h1>
                <div className="flex shrink-0 items-center gap-2">
                    {actions}
                </div>
            </div>
            {variant !== "bare" && providerName && (
                <div className="mt-1 break-words">
                    <ListingProviderName
                        name={providerName}
                        id={providerId}
                        isVerified={providerIsVerified}
                        providerType={providerType}
                    />
                </div>
            )}

            {contact && (
                <div className="mt-6">
                    {contactHelp(
                        <Button
                            type="button"
                            emphasis="lead"
                            size="primary-action"
                            className="w-full text-label"
                            onClick={contact.onClick}
                        >
                            {contact.label}
                        </Button>,
                    )}
                </div>
            )}
        </div>
    );
}
